// import { Icon } from '@iconify/react';
// import React, { useEffect } from 'react';
// import { Link } from 'react-router-dom';

// export default function Post({
//   title,
//   thumbUrl,
//   date,
//   btnText,
//   href,
//   socialShare,
//   variant,
//   lightbox,
// }) {
//   useEffect(() => {
//     if (!lightbox) return;
//     const fancyCssUrl = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui/dist/fancybox.css';
//     const fancyJsUrl = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui/dist/fancybox.umd.js';

//     if (!document.querySelector(`link[href="${fancyCssUrl}"]`)) {
//       const link = document.createElement('link');
//       link.rel = 'stylesheet';
//       link.href = fancyCssUrl;
//       document.head.appendChild(link);
//     }

//     function initFancybox() {
//       try {
//         if (window.Fancybox && window.Fancybox.bind) {
//           window.Fancybox.bind('[data-fancybox="blogs"]', {});
//         }
//       } catch (e) {}
//     }

//     if (window.Fancybox) {
//       initFancybox();
//     } else if (!document.querySelector(`script[src="${fancyJsUrl}"]`)) {
//       const s = document.createElement('script');
//       s.src = fancyJsUrl;
//       s.async = true;
//       s.onload = initFancybox;
//       document.body.appendChild(s);
//     }
//   }, [lightbox]);
//   return (
//     <div className={`cs_post cs_style_1 ${variant}`}>
//       {lightbox && thumbUrl ? (
//         <a data-fancybox="blogs" href={thumbUrl} className="cs_post_thumb cs_view_mouse">
//           <img src={thumbUrl} alt={title} />
//         </a>
//       ) : (
//         <Link to={href} className="cs_post_thumb cs_view_mouse">
//           <img src={thumbUrl} alt={title} />
//         </Link>
//       )}
//     </div>
//   );
// }

import React, { useEffect, useRef } from "react";
import "./Post.scss";

const brands = [
  {
    id: 1,
    name: "Cognivance",
    logo: "/images/icons/cognivance.png",
  },
  {
    id: 2,
    name: "Rozucel",
    logo: "/images/icons/rozucel.png",
  },
  {
    id: 3,
    name: "Alzavia",
    logo: "/images/icons/alzavia.png",
  },
  {
    id: 4,
    name: "Pregacel",
    logo: "/images/icons/pregacel.png",
  },
    {
    id: 5,
    name: "solvira",
    logo: "/images/icons/solvira.png",
  },
      {
    id: 6,
    name: "migrenta",
    logo: "/images/icons/migrenta.png",
  },
        {
    id: 7,
    name: "riventra",
    logo: "/images/icons/riventra.png",
  },
{
    id: 8,
    name: "Cognivance",
    logo: "/images/icons/cognivance.png",
  },
  {
    id: 9,
    name: "Rozucel",
    logo: "/images/icons/rozucel.png",
  },
  {
    id: 10,
    name: "Alzavia",
    logo: "/images/icons/alzavia.png",
  },
  {
    id: 11,
    name: "Pregacel",
    logo: "/images/icons/pregacel.png",
  },
    {
    id: 12,
    name: "solvira",
    logo: "/images/icons/solvira.png",
  },
      {
    id: 13,
    name: "migrenta",
    logo: "/images/icons/migrenta.png",
  },
        {
    id: 14,
    name: "riventra",
    logo: "/images/icons/riventra.png",
  },
];


function BrandTrack({ direction = "ltr" }) {
  const doubled = [...brands, ...brands, ...brands, ...brands];
  return (
    <div className={`brand-track brand-track--${direction}`}>
      <div className="brand-track-inner">
        {doubled.map((brand, i) => (
          <div className="brand-card" key={`${brand.id}-${i}`}>
            <img src={brand.logo} alt={brand.name} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default function BrandSection() {
  useEffect(() => {
    const styleEl = document.createElement("style");
    // styleEl.textContent = css;
    document.head.appendChild(styleEl);
    // return () => document.head.removeChild(styleEl);
  }, []);

  return (
    <section className="brand-section">
      <div className="brand-header">
        <p className="brand-eyebrow">Trusted Partners</p>
        <h2 className="brand-title">
          Brands That <span>Believe</span>
        </h2>
        <p className="brand-subtitle">
          Collaborating with the world's most iconic companies
        </p>
      </div>

      <div className="brand-tracks">
        <BrandTrack direction="ltr" />
        <BrandTrack direction="rtl" />
      </div>

      {/* <div className="brand-stats">
        {[
          { num: "200+", label: "Global Brands" },
          { num: "14", label: "Years Active" },
          { num: "98%", label: "Retention Rate" },
          { num: "40+", label: "Countries" },
        ].map((s) => (
          <div className="brand-stat" key={s.label}>
            <span className="brand-stat-num">{s.num}</span>
            <span className="brand-stat-label">{s.label}</span>
          </div>
        ))}
      </div> */}
    </section>
  );
}
